import { render, staticRenderFns } from "./BottomPage.vue?vue&type=template&id=d69b3108&scoped=true"
import script from "./BottomPage.vue?vue&type=script&lang=js"
export * from "./BottomPage.vue?vue&type=script&lang=js"
import style0 from "./BottomPage.vue?vue&type=style&index=0&id=d69b3108&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d69b3108",
  null
  
)

export default component.exports